export default (params) => {
  const _query = {
    userIdList: params.userId,
    gender: params.gender,
    category: params.category,
    platformId: params.platformId,
    createdTimeStart: params.startTime,
    createdTimeEnd: params.endTime,
    markStatus: params.markStatus,
    markTimes: params.markTimes,
  }
  const _filterQuery = {}
  Object.keys(_query).forEach(key => {
    if (_query[key]) {
      _filterQuery[key] = _query[key]
    }
  })
  const queryString = new URLSearchParams(Object.entries(_filterQuery)).toString()
  return queryString
}
